import { Typography } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { trackContactUsClick } from '../../helpers/analytics';

const { Paragraph } = Typography;

interface ContactUsProps {
  wrapperClass?: string;
  page?: string;
}

export const ContactUs: React.FC<ContactUsProps> = ({
  wrapperClass = '',
  page,
}) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'loginAndSignup',
  });

  const handleContactUsClick = () => {
    trackContactUsClick(page);
  };

  return (
    <div className={wrapperClass}>
      <Paragraph className="!tw-m-0 tw-text-[13px] !tw-text-[--color-text-weaker]">
        {t('havingTroubleToLogin')}
        <a
          href="mailto:support@chaosarchitects.com"
          onClick={handleContactUsClick}
          className={classNames(
            'tw-ml-1 tw-font-medium !tw-underline tw-underline-offset-2',
            '!tw-text-[--color-text-secondary] hover:!tw-text-[var(--color-secondary)]',
          )}
        >
          {t('contactUs')}
        </a>
      </Paragraph>
    </div>
  );
};
